package de.katoonerie.content

import androidx.compose.runtime.Composable
import app.softwork.routingcompose.NavLink
import de.katoonerie.components.AtSymbol
import de.katoonerie.components.Container
import de.katoonerie.components.LinkIcon
import de.katoonerie.components.VideoCameraIcon
import de.katoonerie.util.withPreview
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Footer(preview: Boolean) {
    Footer {
        Container(attrs = {
            classes("py-8")
        }) {
            Div(attrs = {
                classes("flex", "flex-col", "px-4")
            }) {
                A(href = "https://katoonerie.de", attrs = {
                    classes("px-4", "py-1", "font-semibold")
                }) {
                    LinkIcon(attrs = { classes("w-5", "h-5", "mr-2", "inline-block", "text-zinc-400") })
                    Text("Katoonerie.de")
                }
                A(href = "https://www.youtube.com/@katechetischecartoonerie7158", attrs = {
                    classes("px-4", "py-1", "font-semibold")
                    target(ATarget.Blank)
                }) {
                    VideoCameraIcon(attrs = { classes("w-5", "h-5", "mr-2", "inline-block", "text-zinc-400") })
                    Text("Katechetische Cartoonerie YouTube Kanal")
                }
                A(href = "mailto:katoonerie@gmail.com", attrs = {
                    classes("px-4", "py-1", "font-semibold")
                    target(ATarget.Blank)
                }) {
                    AtSymbol(attrs = { classes("w-5", "h-5", "mr-2", "inline-block", "text-zinc-400") })
                    Text("katoonerie@gmail.com")
                }
            }
            Div(attrs = {
                classes("flex", "justify-evenly", "md:flex-row", "py-8")
            }) {
                Span(attrs = { classes("p-4") }) {
                    Text("Katoonerie © 2023")
                }
                NavLink(to = "/impressum".withPreview(preview), attrs = { classes("hover:underline", "p-4") }) {
                    Text("Impressum § Datenschutz")
                }
                A(href = "mailto:katoonerie@gmail.com", attrs = {
                    classes("hover:underline", "p-4")
                    target(ATarget.Blank)
                }) {
                    Text("Kontakt")
                }
            }
        }
    }
}
